module.exports = __webpack_public_path__ + "img/ic_help_white_24px.89b787fd.png";